import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { ThemeModeType, ThemeModeService } from "./theme-mode.service";
import { SharedModule } from "../../../../../shared/shared.module";

@Component({
  selector: "app-theme-mode-switcher",
  templateUrl: "./theme-mode-switcher.component.html",
  imports: [CommonModule, SharedModule],
})
export class ThemeModeSwitcherComponent implements OnInit {
  @Input() toggleBtnClass = "";
  @Input() toggleBtnIconClass = "svg-icon-2";
  @Input() menuPlacement = "bottom-end";
  @Input() menuTrigger = "{default: 'click', lg: 'hover'}";
  mode$: Observable<ThemeModeType>;
  menuMode$: Observable<ThemeModeType>;

  private readonly modeService = inject(ThemeModeService);

  ngOnInit(): void {
    this.mode$ = this.modeService.mode.asObservable();
    this.menuMode$ = this.modeService.menuMode.asObservable();
  }

  switchMode(_mode: ThemeModeType): void {
    this.modeService.switchMode(_mode);
  }
}
